import { createContext, useContext } from 'react';

interface SentryContextType {
  addNavigationBreadcrumb: (to: string) => void;
  addApiBreadcrumb: (method: string, endpoint: string, status?: number) => void;
}

export const SentryContext = createContext<SentryContextType | null>(null);

export const useSentry = () => {
  const context = useContext(SentryContext);
  if (!context) {
    throw new Error('useSentry must be used within SentryProvider');
  }
  return context;
};
